import { FC } from "react";
import { Redirect } from "react-router-dom";
import withCompositeResource, { WrappedComponentProps } from "@/components/recource/CompositeResource";
import { useResourceRegister } from "@/utils/resourceRegister";
import { useHasFeature } from "@/utils/useHasFeature";


const SecureFileCompositeContent: FC<WrappedComponentProps> = ({
  children,
}) => {
  const hasFeature = useHasFeature()
  useResourceRegister({name: 'settings/governance/classification/data-access-role/grants'})
  useResourceRegister({name: 'secure-files-base-info-type'})
  useResourceRegister({ name: 'secure-files-ownership-statis-1' })
  useResourceRegister({ name: 'secure-files-ownership-statis-2' })
  useResourceRegister({ name: 'secure-files/file/data-owner-group' })
  useResourceRegister({ name: 'secure-files/plainfile/data-owner-group' })

  if (!hasFeature.OnDataSecureFile) {
    return (
      hasFeature.requested ? <Redirect to="/" /> : null
    )
  }
  return (
    <>{children}</>
  )
}

export const SecureFileComposite = withCompositeResource(SecureFileCompositeContent);
